module.exports = __webpack_public_path__ + "img/med0007.2b66510b.png";